<!--
 * @Description: 请输入当前文件描述
 * @Author: Wang Xiaowu (wangxiaowu@example.com)
 * @Date: 2023-11-13 16:58:52
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-14 14:55:09
 -->
<template>
  <div class="sleepReport">
    <div class="bigBox">
      <div class="route">
        <span @click="handleBlack" style="cursor: pointer;">睡眠报告</span> <i class="el-icon-arrow-right"></i> <span>{{urlName}}</span>
      </div>
      <div class="boxTab">
        <tab-block @tabToggle="toggleCom" :tabs="tabs"></tab-block>
      </div>
      <div class="page-box">
        <component :is="component" :deviceId="deviceId"></component>
      </div>
    </div>  
  </div>
</template>

<script>
import dailyStatistics from './deviceDetails/dailyStatistics'
import weeklyStatistics from './deviceDetails/weeklyStatistics'
import monthlyStatistics from './deviceDetails/monthlyStatistics'
import annualStatistics from './deviceDetails/annualStatistics'
import TabBlock from '@/components/common/TabBlock'
export default {
  props: {
  },
  components: {
    dailyStatistics,
    weeklyStatistics,
    monthlyStatistics,
    annualStatistics,
    TabBlock,
  },
  data() {
    return {
      dateTime: '',
      sleepData: {},
      deviceId: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()- 3600 * 1000 * 24; // 今天之前禁用，减去一天的毫秒数，否则今天也将禁用
        }
      },
      tabs: [{
          name: '日统计',
          code: 'dailyStatistics'
        }, {
          name: '周统计',
          code: 'weeklyStatistics'
        },
        {
          name: '月统计',
          code: 'monthlyStatistics'
        }, {
          name: '年统计',
          code: 'annualStatistics'
        },
      ],
      component: '',
      urlName: '日统计',
    }
  },
  created() {
    // 初始化获取时间
    let date = new Date(); // 获取当前时间戳
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day = date.getDate();
    day = day < 10 ? "0" + day : day;
    this.dateTime = year + "-" + month + "-" + day;
    this.deviceId = Number(this.$route.query.id)
    // this.handleInfo()
  },
  methods: {
    // 点击返回睡眠报告
    handleBlack () {
      let sleepData = {
        deviceId: this.$route.query.id,
      }
      this.$router.push({path: '/deviceSleep', query: {data: sleepData}})
    },
    // 初始化获取数据
    handleInfo () {
      this.request.post('/front/device/sleep/mulSleepDay', {
        // deviceId: this.$route.query.deviceId,
        deviceId: this.deviceId,
        time: this.dateTime,
        isHome: 0
      }).then(res => {
        if (res.code == 200) {
          this.sleepData = res.data
        }
      })
    },
    // 切换tab
    toggleCom(tabCode) {
      this.urlName = tabCode.name
      this.component = tabCode.code
    },
  }
};
</script>

<style lang="scss" scoped>
.sleepReport {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  .bigBox {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 15px 15px 15px;
    .route {
      height: 40px;
      border-bottom: 1px solid #DEDEDE;
      line-height: 40px;
      color: #768082;
      font-family: AlibabaPuHuiTi-Bold;
    }
    .boxTab {
      margin-top: 10px;
    }
    .page-box {
      width: 100%;
      height: calc(100% - 90px);
    }
  }
  
}
</style>